class VanillaVoiceMore {
  constructor() {
    this.list = document.getElementById("js-voice-list");
    this.items = document.querySelectorAll(".js-voice-item");
    this.moreBtn = document.getElementById("js-voice-more");
    this.mediaQuery = window.matchMedia("(max-width: 1279px)");
    this.initialShowCount = 3;
    this.isOpened = false;

    if (!this.list || !this.items.length || !this.moreBtn) return;

    this.init();
  }

  init() {
    this.handleMediaChange();
    this.bindEvents();
  }

  bindEvents() {
    this.moreBtn.addEventListener("click", () => {
      this.showAllItems();
    });

    this.mediaQuery.addEventListener("change", () => {
      this.handleMediaChange();
    });
  }

  handleMediaChange() {
    if (this.mediaQuery.matches) {
      this.setMobileView();
    } else {
      this.setDesktopView();
    }
  }

  setMobileView() {
    this.isOpened = false;

    this.items.forEach((item, index) => {
      if (index >= this.initialShowCount) {
        item.style.display = "none";
      } else {
        item.style.display = "block";
      }
    });

    if (this.items.length > this.initialShowCount) {
      this.moreBtn.style.display = "flex";
    } else {
      this.moreBtn.style.display = "none";
    }
  }

  setDesktopView() {
    this.items.forEach((item) => {
      item.style.display = "";
    });

    this.moreBtn.style.display = "";
    this.isOpened = false;
  }

  showAllItems() {
    if (!this.mediaQuery.matches) return;

    this.items.forEach((item) => {
      item.style.display = "block";
    });

    this.moreBtn.style.display = "none";
    this.isOpened = true;
  }
}

export default VanillaVoiceMore;
